// A role suggested by text assist only fills an empty Role Title; anything the user has
// already typed (or that was saved) is kept.
export const mergeSuggestedRole = (current, suggested) => {
  if (typeof current === 'string' && current.trim()) {
    return current;
  }
  const suggestion = typeof suggested === 'string' ? suggested.trim() : '';
  return suggestion || current;
};
